/**
 * formatFieldValue — display helper for CV profile fields
 *
 * Converts raw field values to display strings, handling booleans via i18n keys
 * so they render as "Evet/Hayir" or "Yes/No" instead of "true/false".
 *
 * @param {*} val - raw field value from backend
 * @param {function} t - i18n translation function from useLanguage()
 * @returns {string}
 */
export function formatFieldValue(val, t) {
  if (val === null || val === undefined) return '';
  if (typeof val === 'boolean') {
    return t(val ? 'cabin.common.yes' : 'cabin.common.no');
  }
  if (typeof val === 'object') {
    // Arrays or nested objects — stringify as fallback, caller should handle separately
    return JSON.stringify(val);
  }
  return String(val);
}
